<div class="acceso">
    <div class="box-acceso">
        <h1>Acceso Denegado</h1>
        <div class="flex-end">
            <button class="btn-fill" (click)="login()">login</button>
        </div>
    </div>
</div>